import { render, staticRenderFns } from "./sync-details.vue?vue&type=template&id=e52130be"
import script from "./sync-details.vue?vue&type=script&lang=js"
export * from "./sync-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports